module.exports = __webpack_public_path__ + "img/hero-mark.75b559d3.svg";